// project imports
import MainLayout from '../layout/MainLayout';

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MainLayout />,
    children: []
};

export default AuthenticationRoutes;
